export const KEY_CATEGORY_NAME = "categoryName";
export const KEY_DESCRIPTION = "description";
export const KEY_CREATED_BY = "createdBy";
export const KEY_TAGGED_CALLS = "createdOn";
export const KEY_ACTIONS = "actions";